export const EMPTY_FORM = {
  asset_tag: '',
  brand_model: '',
  serial_number: '',
  project_number: '',
  assignee_email: '',
  equipment_type: '',
  condition: '',
  country: '',
  status: 'Active',
};

export const EMPTY_REGISTER_ITEM = {
  asset_tag: '',
  brand_model: '',
  serial_number: '',
  project_number: '',
  equipment_type: '',
  condition: '',
  country: '',
  assignee: '',
  assignee_email: '',
  status: '',
  date_sent_out: '',
  date_returned: '',
};

export const REQUIRED_FIELDS = ['asset_tag', 'brand_model', 'equipment_type', 'condition'];

export const LOOKUP_SOURCE_REGISTER = 'register';
export const LOOKUP_SOURCE_ASSET_TIGER = 'assettiger';

export const EQUIPMENT_TYPES = ['Laptop', 'Phone', 'Tablet', 'Other'];
export const CONDITIONS = ['Excellent', 'New', 'Good', 'Fair', 'Poor'];
export const STATUS_FILTERS = ['Active', 'Returned'];

export const REGISTER_COLUMNS = [
  { key: 'asset_tag', label: 'Asset Tag Number' },
  { key: 'equipment_type', label: 'Equipment Type', kind: 'choice' },
  { key: 'assignee', label: 'Assignee' },
  { key: 'project_number', label: 'Project Number' },
  { key: 'status', label: 'Status', kind: 'status' },
  { key: 'condition', label: 'Condition', kind: 'choice' },
  { key: 'date_sent_out', label: 'Date Sent Out', kind: 'date' },
  { key: 'date_returned', label: 'Date Returned', kind: 'date' },
  { key: 'serial_number', label: 'Serial' },
];

export const SHAREPOINT_REGISTER_URL =
  'https://pacgroup.sharepoint.com/sites/PACITDepartment/Lists/PAC%20IT%20Asset%20Register/AllItems.aspx?e=9XdUXB&CID=33999d7d%2Dfc44%2D4f4f%2Da729%2Db2ca5bebbb5c';

export const COUNTRIES = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda',
  'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain',
  'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan',
  'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria',
  'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia', 'Cameroon', 'Canada',
  'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros',
  'Congo (Congo-Brazzaville)', 'Congo (DRC)', 'Costa Rica', 'Croatia', 'Cuba',
  'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic',
  'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia',
  'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon', 'Gambia', 'Georgia',
  'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau',
  'Guyana', 'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran',
  'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan',
  'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho',
  'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Madagascar', 'Malawi',
  'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius',
  'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco',
  'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand',
  'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia', 'Norway', 'Oman',
  'Pakistan', 'Palau', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru',
  'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia', 'Rwanda',
  'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa',
  'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia',
  'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands',
  'Somalia', 'South Africa', 'South Korea', 'South Sudan', 'Spain', 'Sri Lanka',
  'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan',
  'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago',
  'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine',
  'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan',
  'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe',
];
